import React, { useEffect } from 'react';
import { groupBy, orderBy } from '../../../utils/collections';
import { useQuery } from '@tanstack/react-query';
import { XMasonry, XBlock } from 'react-xmasonry';
import LoadingIndicator from 'Components/Global/loading-indicator/loading-indicator';
import SharepointLink from 'Components/Global/SharepointLink/SharepointLink';
import { GetRecruitingItems } from '../../../api/recruiting';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import './recruiting-list.scss';
import LaunchOutlinedIcon from '@mui/icons-material/LaunchOutlined';
import RenderIcon from '../../Software/Subpages/SoftwareList/RenderIcon';

import Typography from '@mui/material/Typography';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';

function CategorizeArray(data) {
  const order = {
    Recruiting: 1,
    Selection: 2,
  };
  const grouped = groupBy(data, 'Category');
  const temp = orderBy(
    Object.entries(grouped).map(([name, group]) => ({
      name,
      children: group.map(({ FormName, FileURL, LinkTypeID }) => ({
        FormName,
        FileURL,
        LinkTypeID,
      })),
    })),
    (o) => order[o.name]
  );
  return temp;
}

export default function RecruitingView() {
  const data = useQuery({
    queryKey: ['recruitinglib'],
    queryFn: () => GetRecruitingItems()(),
  });

  useEffect(() => {
    if (data.isError) {
      console.log('Failed to fetch recruiting items');
    }
  }, [data.isError]);

  if (data.isPending) {
    return <LoadingIndicator />;
  }
  if (data.isSuccess) {
    return (
      <div className="mt-3">
        <XMasonry maxColumns={2} responsive targetBlockWidth={750}>
          {CategorizeArray(JSON.parse(data.data)).map((category, index) => (
            <XBlock key={category.name}>
              <div className="m-2 software-list-wrapper">
                <Accordion defaultExpanded sx={{ backgroundColor: '#f2f2f2' }}>
                  <AccordionSummary
                    id={`panel-${index}`}
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel3-content"
                    sx={{ backgroundColor: '#0075BF' }}
                  >
                    <Typography sx={{ color: '#fff' }}>
                      {category.name != 'null' ? category.name : 'Other'}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <ul>
                      {category.children.map((recruitingitem, i) => (
                        <li
                          key={recruitingitem.FormName + i}
                          className="d-flex align-items-center "
                        >
                          <RenderIcon>
                            <LaunchOutlinedIcon />
                          </RenderIcon>
                          <SharepointLink
                            linkType={recruitingitem.LinkTypeID}
                            link={recruitingitem.FileURL}
                            baseUrl={`${process.env.REACT_APP_AGENTPORTAL_PREFIX}/Recruiting`}
                            fileName=""
                          >
                            {recruitingitem.FormName}
                          </SharepointLink>
                        </li>
                      ))}
                    </ul>
                  </AccordionDetails>
                </Accordion>
              </div>
            </XBlock>
          ))}
        </XMasonry>
      </div>
    );
  }
  if (data.isError) {
    return <>failed to fetch</>;
  }

  return <>default</>;
}
